import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import {
  deleteDocumentsDynamic,
  getDocumentsDynamic,
} from "../../../apis/AllDocuments";
import getDocsColumns from "../../../const/columns/AllDocumentsColumns";

const NewDocumentsList = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const res = await getDocumentsDynamic();
      console.log(res.result[0], ":w6w96w96829w6982968w986");
      setDocuments(res?.result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching documents:", error);
      setLoading(false);
    }
  };

  const deleteDocuments = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Document?",
    );
    if (isConfirmed) {
      const res = await deleteDocumentsDynamic(id);
      // console.log(res, ":w6w96w96829w6982968w986");
      fetchDocuments();
    }
  };
  const columns = getDocsColumns(deleteDocuments);

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link to="/AddDocuments" className="btn btn-primary mb-3">
              Add Documents
            </Link>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <Table
                columns={columns}
                dataSource={documents?.length > 0 ? documents : []}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewDocumentsList;
